<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Group Subscription Details</h1>
      <div class="row">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>                  
                  <th class="text-left">User</th>
                  <th class="text-left">Publication</th>
                  <th class="text-left">Type</th>
                  <th class="text-left">UUID</th>
                  <th class="text-left">Start Date</th>
                  <th class="text-left">End Date</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in resultQuery" :key="item.id">
                  <td>{{ item.user.firstName }}</td>
                  <td>{{ item.publication.Title }}</td>
                  <td>{{ item.subscriptionType }}</td>
                  <td>{{ item.license_uuid }}</td>
                  <td>{{ item.startDate | formatDate }}</td>
                  <td>{{ item.endDate | formatDate }}</td>
                  <td>
                      <v-icon class="mr-2 mdi-license" @click="onLicense(item)"
                          >mdi-license</v-icon
                        >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import * as api from "@/api";
export default {
  name: "GroupSubscriptionDetails",
  created() {
    this.getGroupSubscription(this.$route.params.id);
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    resultQuery() {
      if (this.Search) {
        return this.list.filter((item) => {
          return this.Search.toLowerCase()
            .split(" ")
            .every((v) => item.email.toLowerCase().includes(v));
        });
      } else {
        return this.list;
      }
    },
  },

  methods: {
    getGroupSubscription(id) {
      new Promise((resolve, reject) => {
        api
          .getByID("user-license/group-subscription", id)
          .then((response) => {
            resolve(response);
            this.list = response.data;
            console.log(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onLicense(item)
    {
      window.location = `/licensesStatus/${item.id}`
    }
  },
  data() {
    return {
      list: [],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/views/GroupSubscriptionDetails.vue